/**
 * 実行デコレータ
 */
export const Execution = (...args: any[]): any => {
  return <T extends {new(..._args: any[]): {}}>(target: T): void => {
    new target(args);
  };
};
